module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_Dec2019-d95febf6c434ebdaad2da62a8f9e9c48.pdf";